exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2xmX2WA82Bf843SSU9Xx5M{width:100%}html[dir] ._2xmX2WA82Bf843SSU9Xx5M ._1jYjDXXrY5R0Ms8V21UCve{margin-bottom:10px}", ""]);

// exports
exports.locals = {
	"container": "_2xmX2WA82Bf843SSU9Xx5M",
	"storageAccount": "_1jYjDXXrY5R0Ms8V21UCve"
};